import { memo } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { EditorialAssetSearchResultItem } from 'utility/types/dataProvider';

type SectionsFieldProps = {
  record: EditorialAssetSearchResultItem;
};

const EditorialSectionsField = memo(({ record }: SectionsFieldProps) => {
  const { sections = [] } = record || {};
  const sectionsLength = sections ? sections.length : 0;
  const sectionsText = sections?.[0];
  return (
    <Tooltip
      title={
        sectionsLength > 1 ? (
          <>
            {sections.map((section: string, index: number) => (
              <Typography
                variant="caption"
                key={index}
                sx={{
                  display: 'block',
                }}
              >
                {section}
              </Typography>
            ))}
          </>
        ) : (
          ''
        )
      }
      placement="top"
      arrow
    >
      <Typography
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        })}
      >
        {sectionsText}
        {sectionsLength > 1 && (
          <span
            style={{
              fontSize: 12,
            }}
          >
            ({sectionsLength})
          </span>
        )}
      </Typography>
    </Tooltip>
  );
});

export default EditorialSectionsField;
